import { render, staticRenderFns } from "./xingfuxuege.vue?vue&type=template&id=5a72bdbe&"
import script from "./xingfuxuege.vue?vue&type=script&lang=js&"
export * from "./xingfuxuege.vue?vue&type=script&lang=js&"
import style0 from "./xingfuxuege.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports